import { createContext, useState } from "react";

const ContextContracting = createContext({});

function ProviderContracting(props) {
	const [custumerAsaas, setCustumerAsaas] = useState(null);
	const [loading, setLoading] = useState(false);
	const [stage, setStage] = useState(1);

	const handleNextStage = () => {
		setStage((prev) => prev + 1);
	};

	const handlePriorStage = () => {
		setStage((prev) => prev - 1);
	};
	//passa os dados para o bodyBilling
	//o custumerAsaas é o id do cliente que é passado no primeiro passo
	//quando atualiza os cados do cliente
	const createBodyBilling = () => {
		return {
			ambiente: 1,
			customer: custumerAsaas,
			billingType: "UNDEFINED",
			description: "Fatura PDV",
			daysAfterDueDateToRegistrationCancellation: 15,
			// externalReference: "",
			installmentCount: 0,
			installmentValue: 0,
			// value: 130,
			// totalValue: 0,
			// dueDate: "2025-02-20",
			discountDueDateLimitDays: 0,
			discountType: "PERCENTAGE",
			discountValue: 0,
			interestValue: 0,
			fineValue: 0,
			fineType: "PERCENTAGE",
			postalService: false,
		};
	};

	return (
		<ContextContracting.Provider
			value={{
				custumerAsaas,
				stage,
				loading,

				setCustumerAsaas,
				setStage,
				setLoading,

				handleNextStage,
				handlePriorStage,

				createBodyBilling,
			}}
		>
			{props.children}
		</ContextContracting.Provider>
	);
}

export { ContextContracting, ProviderContracting };
